import { html } from 'lit';
import { nothing } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { featureTemplate } from './features.tmpl';
import { localDate, localTime, replaceTooltips } from './util';
import comsStore from '../../state/ComsStore';
import { stripHtml } from '../../util/helpers';
export const consentTemplate = (consent) => {
    var _a, _b, _c;
    return html `
    ${consent.hintBefore ? html `<div class="coms-hint-before">${unsafeHTML(consent.hintBefore)}</div>` : nothing}
    <div class="coms-panel ${consent.className ? `coms-panel--${consent.className}` : ''}">
      ${consent.modeconstraint == 'edit' ? html `<small class="join-hint">Diese Einwilligung ist aus der Zusammenführung der vorhergehenden Einwilligungen entstanden</small>` : nothing}
      <tef-coms-multi-checkbox
          value="${ifDefined(consent.granted)}"
          @change=${(event) => { consent.change(event.detail); }}
          ?disabled="${(_b = (((_a = comsStore.identity) === null || _a === void 0 ? void 0 : _a.readonly) || consent.deprecated)) !== null && _b !== void 0 ? _b : false}" 
      >
        <p>
          ${unsafeHTML(replaceTooltips(consent.scope))}
          ${((_c = comsStore.config) === null || _c === void 0 ? void 0 : _c.showVersions) ? html `<small>(Vers. ${consent.version})</small>` : nothing}
        </p>
        ${consent.features.map((f) => html `${featureTemplate(f, !!consent.deprecated)}`)}
          ${consent.client && consent.date ? html `
          <small>
            <tef-coms-icon icon="clock"></tef-coms-icon>
            <a
              role="button"
              @click=${() => {
        comsStore.history.configId = consent.configId;
        comsStore.history.consentShortScope = consent.shortScope;
    } /* eslint-enable @typescript-eslint/indent */}
            >
              Letzte Änderung am
              ${localDate(consent.date)} um ${localTime(consent.date)} Uhr über ${consent.client}
            </a>&nbsp
          </small>
        ` : nothing}
      </tef-coms-multi-checkbox>
    </div>
    ${consent.hintAfter ? html `<div class="coms-hint-after">${unsafeHTML(consent.hintAfter)}</div>` : nothing}
`;
};
export const consentTemplateOverview = (consent) => {
    const { featureTitlesAsString } = consent;
    return html `
      <div class="row">
        <div class="col">${stripHtml(consent.shortScope)}</div>
              ${featureTitlesAsString /* eslint-disable @typescript-eslint/indent */
        ? html `
                        <div class="col">
                          <strong>${featureTitlesAsString}</strong>
                        </div>`
        : nothing
    /* eslint-enable @typescript-eslint/indent */ }
      </div>
  `;
};
//# sourceMappingURL=consent.tmpl.js.map